import styled from "styled-components";
export const TargetCardStyle = styled.div`
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#000")};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: ${({ theme }) => theme.shadow};
  transition: all 0.3s;
  border: 2px solid transparent;
  &:hover {
    filter: grayscale(0.2);
    cursor: pointer;
    border: 2px solid #36006950;
  }
`;
